<template lang="html">
  <div :class="['side-block',state]" :style="'height:' + listH + 'px'">
        <div ref="el" class="block-inner">
            <div class="block-ttl">
                 <div class="ttl-name">{{classKey}}</div>
                 <div class="block-icon" @click="listCtrls()">
                      <span v-if="state=='act'">展开</span>
                      <span v-else>收起</span>
                      <van-icon :class="['icon',state]" class-prefix="iconfont" name="slideOpen" />
                 </div>
            </div>
            <div class="block-content">
                  <div v-for="(item,index) in classDat"
                      :key="index"
                      :class="['select-item ellipsis',{'act':selectedMap[0][item.id]}]"
                      @click="select(item)">
                         {{item.text || item.name}}
                  </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
     props:['classDat','classKey','selectedArr'],
     watch:{
         selectedArr:function(newArr){
             this.selectedSet(newArr);
         }
     },
     data(){
         return{
             listH:'',
             state:'',
             selectedMap:[{}]
         }
     },
     methods:{
         listCtrls:function(){
             if(this.state != 'act'){
                this.state = 'act';
             }else {
                this.state = '';
             }
         },
         select:function(item){
             item.classKey = this.classKey;
             this.$emit('select',item);
         },
         selectedSet:function(newArr){
             let newMap = {};
             for(let i = 0;i < newArr.length;i++){
                 newMap[newArr[i].id] = true;
             };
             this.selectedMap.splice(0,1,newMap);
         }
     },
     mounted:function(){
        this.listH = this.$refs.el.offsetHeight;
        this.selectedSet(this.selectedArr);
     },
     updated:function(){
        this.listH = this.$refs.el.offsetHeight;
     }
}
</script>

<style lang="css" scoped>

.side-block{
    border-bottom: 1px solid #efefef;
    position: relative;
    overflow: hidden;

    transition-property: all;
    transition-duration: 0.3s;
}

.side-block.act{
    height: 45px !important;
}

.block-ttl{
    height: 45px;
    display: flex;
    align-items: center;
    margin: 0 10px;
    justify-content: space-between;
}

.block-ttl .block-icon span{
    font-size: 14px;
}

.block-ttl .block-icon .icon{
    transform: rotate(-180deg);
    display: inline-block;
    position: relative;
    transition-property: all;
    transition-duration: 0.3s;
}

.block-ttl .block-icon .icon.act{
    transform: rotate(0deg);
}

.select-item{
    font-size: 13px;
    width: 82px;
    color: #666666;
    text-align: center;
    box-sizing: border-box;
    padding: 6px 15px;
    background: #efefef;
    display: inline-block;
    margin: 0 12px;
    margin-bottom: 15px;
    border-radius: 24px;
}

.select-item.act{
    background: #af2d2d;
    color: white;
}

</style>
